export default "__VITE_ASSET__1f787113__"